<template>
<div>
    <modal v-model="addTreatmentModal" title="Selecionar procedimentos" ref="modal" size="lg" id="modal-price-list">
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label class="control-label">Plano</label>
                    <select class="form-control" v-model="budget.plan" @change="changePlan()" v-if="patient">
                        <option :value="null">Particular</option>{{patient}}
                        <option v-for="(plan, i) in patient.dental_plans" :key="'plan_'+i" :value="plan">{{plan.code}} || {{plan.name}}</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label class="control-label">Buscar procedimento</label>
                    <input v-model="search" type="text" class="form-control" placeholder="Busca por código, categoria ou procedimento...">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <table class="table table-striped table-bordered dt-responsive nowrap" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Código</th>
                            <th>Categoria</th>
                            <th>Procedimento</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(treatment, index) in priceList.treatments" :key="index">
                            <td><btn type="success" @click="addBudgetTreatment(treatment)"><i class="fa fa-plus" aria-hidden="true"></i></btn></td>
                            <td>{{treatment.code}}</td>
                            <td>{{treatment.category.category_treatment}}</td>
                            <td>{{treatment.procedure}}</td>
                            <td><currency-input v-model="treatment.price" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div slot="footer">
            <btn type="primary" @click="priceListModal=false">Ok</btn>
        </div>
    </modal>

    <div class="row">
        <div class="col-md-12">
            <div class="box box-default">
                <form id="budget-form">
                    <div class="box-body">
                        <div class="col-xs-12">
                            <h2 class="page-header" id="page-header">
                                <span v-if="editingBudget || newBudgetWithPatient">
                                    <i class="fa fa-user"></i> {{patient.code}} | {{patient.name}} 
                                </span>
                                <span v-else>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <label class="control-label">Paciente</label>
                                                <div class="input-group">
                                                    <multiselect v-model="patient" id="ajax" label="name" track-by="id" placeholder="Busque por nome, cpf, telefone ou o código da ficha." open-direction="bottom"
                                                                selectLabel="Enter para selecionar."
                                                                deselectLabel="Enter para remover."
                                                                @select="changePatient"
                                                                :options="patientOptions"
                                                                :multiple="false"
                                                                :searchable="true"
                                                                :loading="isLoading"
                                                                :preserve-search="true"
                                                                :internal-search="false"
                                                                :clear-on-select="true"
                                                                :close-on-select="true"
                                                                :max-height="450"
                                                                :custom-label="codeWithNameLabel"
                                                                :show-no-results="true" :hide-selected="false" @search-change="this.debouncedGetSearchPatients">
                                                        <span slot="noOptions">Busque por nome, cpf, telefone ou o código da ficha.</span>
                                                        <span slot="noResult">Nenhum resultado encontrado.</span>
                                                    </multiselect>
                                                    <span class="input-group-btn">
                                                        <btn @click="newPatient" type="primary"><i class="fa fa-plus"></i> Novo paciente</btn>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                                <small class="pull-right">Data: {{ moment().format('D/M/Y') }}</small>
                            </h2>
                            <div class="table-responsive">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:5%">Status:</th>
                                            <td>
                                                <div class="input-group date">
                                                    <toggle-button class="form-contol" v-model="budget.status"
                                                        :labels="{checked: 'Aprovado', unchecked: 'Aguardando aprovação'}"
                                                        :width="185"
                                                        :height="35"
                                                        :font-size="12"
                                                        :margin="3"
                                                        :disabled="budgetProp ? budgetProp.status : false"
                                                        :color="{checked: '#23a665', unchecked: '#72859a', disabled: '#CCCCCC'}" />
                                                </div>
                                            </td>
                                            <th style="width:95%" v-if="budgetProp ? budgetProp.status : false"><em style="color: #72859a">Este orçamento está aprovado, por isso não pode ser editado!</em></th>
                                            <td v-if="budgetProp ? budgetProp.status : false"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="box box-default">
                                <div class="box-header with-border">
                                    <i class="fa fa-stethoscope"></i>
                                    <h3 class="box-title">Procedimentos</h3>
                                    <button type="button" class="btn btn-info pull-right" :disabled="budgetProp ? budgetProp.status : false" @click="handleAddTreatment"><i class="fa fa-plus" aria-hidden="true"></i> Adicionar Procedimento</button>
                                </div>
                                <div class="box-body">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="box">
                                                <div class="box-body">
                                                    <table class="table table-striped table-bordered dt-responsive nowrap" cellspacing="0" width="100%">
                                                        <thead>
                                                            <tr>
                                                                <th width="5%">CÓDIGO</th>
                                                                <th width="22%">PROCEDIMENTO</th>
                                                                <th width="15%">DENTE(S)</th>
                                                                <th width="20%">FACE(S)</th>
                                                                <th width="20%">DENTISTA</th>
                                                                <th width="13%">VALOR</th>
                                                                <th width="5%">AÇÃO</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(treatment, i) in budget.treatments" :key="i">
                                                            <td>{{treatment.code}}</td>
                                                            <td>{{treatment.procedure}}</td>
                                                            <td>
                                                                <multiselect v-model="treatment.teeths_id" label="name" track-by="value" placeholder="Dentes" open-direction="bottom"
                                                                            :disabled="budgetProp ? budgetProp.status : false"
                                                                            selectLabel=""
                                                                            deselectLabel=""
                                                                            selectedLabel="Selecionado"
                                                                            :options="teethsOptions"
                                                                            :multiple="true"
                                                                            :clear-on-select="true"
                                                                            :close-on-select="false"
                                                                            :max-height="450"
                                                                            :hide-selected="false">
                                                                </multiselect>
                                                            </td>
                                                            <td>
                                                                <multiselect v-model="treatment.dental_faces" label="name" track-by="value" placeholder="Faces" open-direction="bottom"
                                                                            :disabled="budgetProp ? budgetProp.status : false"
                                                                            selectLabel=""
                                                                            deselectLabel=""
                                                                            selectedLabel="Selecionado"
                                                                            :options="dentalFacesOptions"
                                                                            :multiple="true"
                                                                            :clear-on-select="true"
                                                                            :close-on-select="false"
                                                                            :max-height="450"
                                                                            :hide-selected="false">
                                                                </multiselect>
                                                            </td>
                                                            <td>
                                                                <select class="form-control" :disabled="budgetProp ? budgetProp.status : false" v-model="treatment.dentist_id">
                                                                    <option :value="null" disabled>Dentista</option>
                                                                    <option v-for="(dentist, i) in dentistsOptions" :key="'dentist_'+i" :value="dentist.value">{{dentist.name}}</option>
                                                                </select>
                                                            </td>
                                                            <td><currency-input style="width:100px" :disabled="budgetProp ? budgetProp.status : false" @input="recalculateBudget" v-model="treatment.price" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/></td>
                                                            <td><button type="button" :disabled="budgetProp ? budgetProp.status : false" @click="removeTreatment(i)" class="btn btn-danger"><i class="fa fa-trash-o" aria-hidden="true"></i></button></td>
                                                        </tr>
                                                        <tr v-if="!budget.treatments.length">
                                                            <td colspan="7">
                                                                <alert type="warning"><p class="h4 d-flex align-items-center"><i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i> Adicione procedimentos.</p></alert>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <th>CÓDIGO</th>
                                                                <th>PROCEDIMENTO</th>
                                                                <th>DENTE(S)</th>
                                                                <th>FACE(S)</th>
                                                                <th>DENTISTA</th>
                                                                <th>VALOR</th>
                                                                <th>AÇÃO</th>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-7">
                                 <div class="form-group">
                                    <label>Observações</label>
                                     <textarea :disabled="budgetProp ? budgetProp.status : false" v-model="budget.observation" class="form-control" name="observation" id="" cols="30" rows="10"></textarea>
                                 </div>
                            </div>
                            <div class="col-xs-5">
                                <div class="table-responsive">
                                    <table class="table">
                                        <tr>
                                            <th style="width:50%">Subtotal:</th>
                                            <td id="sub-total">R$ {{formatMoney(budget.subTotal)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Desconto:</th>
                                            <td>
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <currency-input style="width: 120px" v-if="budget.discount_type === '$'" class="form-control"
                                                            :disabled="budgetProp ? budgetProp.status : false"
                                                            v-model="budget.discount" currency="BRL"
                                                            @keyup.native="recalculateBudget()"
                                                            :allow-negative="false"
                                                            :auto-decimal-mode="true"
                                                            :distraction-free="false"/>
                                                        <input v-else type="number" :disabled="budgetProp ? budgetProp.status : false" @keyup="recalculateBudget()" v-model="budget.discount" min="0" max="100" step="0.01" class="form-control">
                                                        <span class="input-group-addon" style="width:0px; padding-left:0px; padding-right:0px; border:none;"></span>
                                                        <select class="form-control" id="discount-type-id" :disabled="budgetProp ? budgetProp.status : false" @change="budget.discount = 0; recalculateBudget()" v-model="budget.discount_type">
                                                            <option value="$">R$</option>
                                                            <option value="%">%</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Entrada:</th>
                                            <td>
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <div class="input-group-addon">R$ </div>
                                                        <currency-input style="width: 140px" class="form-control" :disabled="budgetProp ? budgetProp.status : false" @change="recalculateBudget()" v-model="budget.entrance" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Parcelar saldo em:</th>
                                            <td>
                                                <div class="form-group">
                                                    <div class="input-group" style="width:180px">
                                                        <input type="number" min="0" class="form-control" :disabled="budgetProp ? budgetProp.status : false" v-model="budget.installment">
                                                        <div class="input-group-addon">vezes</div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Total:</th>
                                            <td id="total">R$ {{formatMoney(budget.total)}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row no-print">
                            <div class="col-xs-12">
                                <button type="button" class="btn btn-success pull-right" :disabled="budgetProp ? budgetProp.status : false" @click="saveBudget"><i class="fa fa-save"></i> Salvar Orçamento</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    import moment from "moment";
    import { CurrencyInput } from 'vue-currency-input'
    import Multiselect from "vue-multiselect";
    import {ToggleButton} from 'vue-js-toggle-button'

    export default {
        name: "BudgetCreateEdit",
        components: { CurrencyInput, Multiselect, ToggleButton },

        props: {
            treatmentsParticular: { type: Array },
            patientProp: { type: Object, default: () => null },
            teethsProp: { type: Array },
            dentalFacesProp: { type: Array },
            dentistsProp: { type: Array },
            budgetProp: { type: Object, default: () => null }
        },

        computed: {
            moment() {
                return moment;
            },

            teethsOptions() {
                let options = [];
                for (let teeth in this.teethsProp) {
                    options.push({ value: this.teethsProp[teeth].id, name: this.teethsProp[teeth].number })
                }
                return options;
            },

            dentalFacesOptions() {
                let options = [];
                for (let dentalFace in this.dentalFacesProp) {
                    options.push({ value: this.dentalFacesProp[dentalFace].id, name: this.dentalFacesProp[dentalFace].dental_face })
                }
                return options;
            },

            dentistsOptions() {
                let options = [];
                for (let dentist in this.dentistsProp) {
                    options.push({ value: this.dentistsProp[dentist].id, name: this.dentistsProp[dentist].name })
                }
                return options;
            },
        },

        data() {
            return {
                optionsToast: { timeout: 6000, position: "topCenter" },
                isLoading: false,
                editingBudget: false,
                newBudgetWithPatient: false,

                patientOptions: [],
                patient: {},
                teeths : this.teethsProp,
                addTreatmentModal: false,

                search: null,
                treatments: [],

                priceList:{
                    id: null,
                    code: null,
                    name: null,
                    active: true,
                    treatments: []
                },

                budget: {
                    id: null,
                    user_id: null,
                    status: false,
                    treatments: [],
                    total: 0,
                    subTotal: 0,
                    discount_type: '$',
                    discount: 0,
                    entrance: 0,
                    installment: 0,
                    observation: null,
                    plan: null
                }
            }
        },

        watch: {
            search: function (search, lastSearch) {
                this.priceList.treatments = [...this.treatments.filter(item => {
                    return (item.category.category_treatment || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0
                    || ((item.procedure || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0)
                    || ((item.code || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0)
                })]
            },
        },

        created(){
            if(this.patientProp)
                this.newBudgetWithPatient = true
            this.patient = this.patientProp
            if(!this.patient)
                this.debouncedGetSearchPatients = _.debounce(this.searchPatients, 500)

            if(this.budgetProp){
                console.log(this.budgetProp)
                this.editingBudget = true
                this.budgetProp.plan = this.budgetProp.plan ? this.budgetProp.user.dental_plans.find((dp) => dp.id == this.budgetProp.plan.id) : null
                this.budgetProp.status = this.budgetProp.status == 'pendent' ? false : true
                this.budget = _.cloneDeep(this.budgetProp)
                this.patient = _.cloneDeep(this.budgetProp.user)
                const teethsOptions = this.teethsOptions
                const dentalFacesOptions = this.dentalFacesOptions
                const budgetTreatments = this.budgetProp.treatments.map(function(treatment) {
                    let dentalFaces = []
                    if(treatment.pivot.dental_face_id_0)
                        dentalFaces.push(treatment.pivot.dental_face_id_0)
                    if(treatment.pivot.dental_face_id_1)
                        dentalFaces.push(treatment.pivot.dental_face_id_1)
                    if(treatment.pivot.dental_face_id_2)
                        dentalFaces.push(treatment.pivot.dental_face_id_2)
                    if(treatment.pivot.dental_face_id_3)
                        dentalFaces.push(treatment.pivot.dental_face_id_3)
                    if(treatment.pivot.dental_face_id_4)
                        dentalFaces.push(treatment.pivot.dental_face_id_4)
                    if(treatment.pivot.dental_face_id_5)
                        dentalFaces.push(treatment.pivot.dental_face_id_5)
   
                    treatment.dental_faces = [...dentalFaces.map((tid) => { return dentalFacesOptions.find((e) => e.value == tid)})]

                    treatment.price = treatment.pivot.unit_price

                    const teethsId = JSON.parse(treatment.pivot.teeths_id)
                    if(teethsId)
                        treatment.teeths_id = [...teethsId.map((tid) => { return teethsOptions.find((e) => e.value == tid)})]
                    treatment.dentist_id = treatment.pivot.dentist_id
   
                    return treatment;
                })
                this.budget.treatments = budgetTreatments
                this.recalculateBudget()
            }
        },

        mounted() {
            const treatments = [...this.treatmentsParticular.map(function(treatment) { treatment.dentist_id = null; return treatment; })]
            this.priceList.treatments = _.cloneDeep(treatments)
            this.treatments = _.cloneDeep(treatments)
        },

        methods:{
            newPatient(){
                alert('Estamos trabalhando nesta nova funcionalidade. Por favor tente mais tarde')
            },

            changePatient(){
                this.budget.plan = null
                this.changePlan()
            },

            changePlan(){
                if(this.budget.plan){
                    const dentalPlan = this.patient.dental_plans.filter((a) => a.id === this.budget.plan.id)
                    if(dentalPlan[0].price_list){
                        const treatments = [...dentalPlan[0].price_list.treatments.map(function(treatment) {
                            treatment.price = treatment.pivot.value
                            treatment.dentist_id = null
                            return treatment;
                        })]
                        this.priceList.treatments = [...treatments]
                        this.treatments = [...treatments];
                    } else {
                        this.priceList.treatments = _.cloneDeep(this.treatmentsParticular)
                        this.treatments = _.cloneDeep(this.treatmentsParticular)
                    }
                } else {
                    this.priceList.treatments = _.cloneDeep(this.treatmentsParticular)
                    this.treatments = _.cloneDeep(this.treatmentsParticular)
                }
            },

            removeTreatment(i){
                this.budget.treatments.splice(i, 1);
                this. recalculateBudget()
            },

            handleAddTreatment(){
                this.addTreatmentModal = true
            },

            addBudgetTreatment(treatment){
                let clone = {...treatment};
                this.budget.treatments.push(clone)
                this. recalculateBudget()
                this.$toast.success('Procedimento adicionado.', 'Sucesso', this.optionsToast);
            },

            recalculateBudget(){
                this.budget.subTotal = this.budget.treatments.map((cT) => cT.price).reduce((a, b) => a + b, 0)
                /** Calcula desconto */
                if(this.budget.discount_type === '$'){
                    this.budget.total = (this.budget.subTotal - this.budget.discount);
                } else if(this.budget.discount_type === '%'){
                    this.budget.total = this.budget.subTotal - (this.budget.subTotal*(this.budget.discount/100));
                }
            },

            async saveBudget(){
                const checkDentist = this.budget.treatments.filter((a)=> a.dentist_id == null)
                const checkTeeths = this.budget.treatments.filter((a)=> a.teeths_id == null)
                if(checkDentist.length){
                    if(checkDentist.length)
                        this.$toast.warning('Todos os tratamentos devem ter um dentista', 'Aviso', this.optionsToast);
                    // if(checkTeeths.length)
                    //     this.$toast.warning('Todos os tratamentos devem ter ao menos um dente', 'Aviso', this.optionsToast);
                    return false
                }
                try {
                    let response = {}
                    this.budget.user_id = this.patient.id
                    let message
                    if(this.budget.id){
                        response = await axios.put('/budget/'+this.budget.id,this.budget);
                        message = 'Orçamento alterado com sucesso. <br> O que deseja fazer?'
                    } else {
                        response = await axios.post('/budget',this.budget);
                        message = 'Orçamento criado com sucesso. <br> O que deseja fazer?'
                    }

                    if(response.data.type == 'success'){
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);

                        let self = this;
                        this.$toast.question(message,'SUCESSO',{
                            timeout: 20000,
                            close: false,
                            overlay: true,
                            toastOnce: true,
                            id: 'budget_',
                            position: "center",
                            buttons: [
                                [
                                    "<button><b>VOLTAR AO PRONTUÁRIO</b></button>",
                                    function(instance, toast) {
                                        instance.hide({ transitionOut: "fadeOut" }, toast);
                                        window.location.href = '/patient/'+self.patient.id+'/edit';
                                    },
                                    true
                                ],
                                [
                                    "<button>IMPRIMIR ORÇAMENTO</button>",
                                    function(instance, toast) {
                                        instance.hide({ transitionOut: "fadeOut" }, toast);
                                        window.open('/budget/pdf/'+response.data.budget.id, '_blank');
                                    }
                                ]
                            ],
                            onClosed: function(instance, toast, closedBy) {
                                window.location.href = '/patient/'+self.patient.id+'/edit';
                            }

                        })
                        
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

            codeWithNameLabel ({ code, name }) {
                return (code ? code + ' | ' : '') + name
            },

            searchPatients (query) {
                this.isLoading = true
                axios.post('/patient/search', {'kw': query})
                    .then(function (response) {
                        this.patientOptions = response.data
                        this.isLoading = false
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error)
                    })
            },

        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .invalid{
        padding: 0px;
        border: 1px solid #dd4b39;
        border-radius: 5px;
    }
</style>